import React from "react";
import { CTAButton } from "./CTAButton";
import HeroFilerCta from "./HeroFilerCta";
import { CTATarget, getCTATrackingTarget } from "./getCTAData";
import styled from "styled-components";
import trackComponentAction from "../analytics/trackComponentAction";
import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";

const navigateToBankruptcyScreener = () => {
  window.open(getMyUpsolveEntryUrl());
};

export const BankruptcyHeroCTA = (props: {
  onClickAskUpsolveAIButton?: () => void;
  trackingPageContext: any;
  ctaTarget: CTATarget;
}) => {
  return (
    <CTAContainer>
      {/* <CTAButton
        onClick={props.onClickAskUpsolveAIButton}
        heading="Ask Upsolve AI"
        subheading="Ask Upsolve’s AI Assistant your debt, credit, and finance questions."
        buttonText="Ask Question"
      /> */}
      {/* hero filer cta being generic sort of breaks this abstraction, but we should be able to break out of it at some point */}
      <HeroFilerCta
        trackingPageContext={props.trackingPageContext}
        target={props.ctaTarget}
        dataTestId="inline-content-cta-mobile"
      />
    </CTAContainer>
  );
};

export const BankruptcyMobileCTA = (props: {
  onClickAskUpsolveAIButton?: () => void;
  trackingPageContext: any;
  ctaTarget: CTATarget;
}) => {
  // const onOpenAIWithMobileCTA = () => {
  //   trackComponentAction({
  //     componentName: "mobileCTA",
  //     actionId: "askAI",
  //     actionMethod: "click",
  //     pageContext: props.trackingPageContext,
  //   });
  //   props.onClickAskUpsolveAIButton();
  // };

  return (
    <CTAContainer>
      {/* <CTAButton
        onClick={onOpenAIWithMobileCTA}
        heading="Ask Upsolve AI"
        subheading="Ask Upsolve's AI Assistant your debt, credit, and finance questions."
        buttonText="Ask Question"
      /> */}
      <HeroFilerCta
        trackingPageContext={props.trackingPageContext}
        target={props.ctaTarget}
        dataTestId="inline-content-cta-mobile"
      />
    </CTAContainer>
  );
};

const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
